export default "__VITE_ASSET__Bin9T0pO__"